/**
 * Shared helpers for file list display (plan / construction / marketing).
 */

export function fileDisplayLabel(file) {
  const d = file?.display_name;
  if (d != null && String(d).trim()) {
    return String(d).trim();
  }
  return file?.original_name || "";
}

/**
 * Issue date only (calendar), Toronto timezone.
 */
export function formatIssueDateCell(file) {
  const raw = file?.issue_date;
  if (raw == null || raw === "") return "—";
  let dateStr = raw;
  if (typeof dateStr === "string") {
    if (!dateStr.includes("+") && !dateStr.includes("Z")) {
      dateStr = dateStr + "Z";
    }
  }
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-CA", {
    timeZone: "America/Toronto",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

/**
 * Upload timestamp, Toronto.
 */
export function formatUploadDateCell(file) {
  const raw = file.upload_time || file.upload_date;
  if (!raw) return "—";
  let dateStr = raw;
  if (typeof dateStr === "string") {
    if (!dateStr.includes("+") && !dateStr.includes("Z")) {
      dateStr = dateStr + "Z";
    }
  }
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-CA", {
    timeZone: "America/Toronto",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function todayIsoDate() {
  return new Date().toISOString().slice(0, 10);
}
